/**
 * Friendly relative time ("2 hours ago", "yesterday") via the native
 * Intl.RelativeTimeFormat — no dependency. Pair the result with the
 * absolute time in a `title=` for precision on hover.
 */
const rtf =
  typeof Intl !== "undefined" && "RelativeTimeFormat" in Intl
    ? new Intl.RelativeTimeFormat(undefined, { numeric: "auto" })
    : null;

const STEPS: ReadonlyArray<[Intl.RelativeTimeFormatUnit, number]> = [
  ["year", 60 * 60 * 24 * 365],
  ["month", 60 * 60 * 24 * 30],
  ["week", 60 * 60 * 24 * 7],
  ["day", 60 * 60 * 24],
  ["hour", 60 * 60],
  ["minute", 60],
  ["second", 1],
];

/** @param epochSeconds committer timestamp (seconds). @param now ms (for tests). */
export function relativeTime(epochSeconds: number, now = Date.now()): string {
  const diffSec = Math.round(epochSeconds - now / 1000); // negative = past
  const abs = Math.abs(diffSec);
  if (abs < 45) return "just now";
  for (const [unit, secs] of STEPS) {
    if (abs >= secs) {
      const value = Math.round(diffSec / secs);
      return rtf
        ? rtf.format(value, unit)
        : `${Math.abs(value)} ${unit}${Math.abs(value) === 1 ? "" : "s"} ago`;
    }
  }
  return "just now";
}

/** Absolute, locale-formatted timestamp for `title=`. */
export function absoluteTime(epochSeconds: number): string {
  return new Date(epochSeconds * 1000).toLocaleString();
}
